export default __webpack_public_path__ + "static/media/award-3.44316a23.webp";